import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import './Home.scss'
import HomeComponenteDestaque from './HomeComponenteDestaque'
import HomeComponenteDestaqueModeloCard from './HomeComponenteDestaqueModeloCard'
import HomeComponenteDestaqueModeloCardGrafico from './HomeComponenteDestaqueModeloCardGrafico'

import { Creators as DestaqueActions } from '_/store/destaque'

class Home extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            destaque: null,
        }
    }

    componentDidMount() {
        this.props.buscaDestaque().then(() => {
            this.setState({
                destaque: this.props.destaque.lista,
            })
        })
    }

    render() {
        let conteudo = this.props.destaque.lista

        return (
            <div className="homeAreaGeral">
                <div className="homeArea1">
                    <div className="homeArea1-1">
                        <HomeComponenteDestaque conteudo={conteudo[0]} />
                    </div>
                </div>
                <div className="homeArea2">
                    <div className="homeArea2-1">
                        <HomeComponenteDestaqueModeloCardGrafico conteudo={conteudo[1]} />
                    </div>
                    <div className="homeArea2-2">
                        <HomeComponenteDestaque conteudo={conteudo[2]} />
                    </div>
                </div>
                <div className="homeArea3">
                    <div className="homeArea3-1">
                        <HomeComponenteDestaqueModeloCard conteudo={conteudo[3]} />
                    </div>
                    <div className="homeArea3-2">
                        <HomeComponenteDestaqueModeloCard conteudo={conteudo[4]} />
                    </div>
                    <div className="homeArea3-3">
                        <HomeComponenteDestaqueModeloCard conteudo={conteudo[5]} />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    destaque: state.basico.entidades.destaque,
})

const mapDispatchToProps = dispatch => bindActionCreators({ ...DestaqueActions }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Home)
